import { agentApiClient } from "./agentApiClient";

export async function chat(
  prompt: string,
  sessionId?: string,
  // Marks an explicit "Continuer" click rather than a message the user typed.
  // Only these count against the per-session resume cap.
  isResume?: boolean,
): Promise<Response> {
  return agentApiClient.post("/api/chat", {
    body: { prompt, sessionId, isResume },
  });
}

export async function reply(
  sessionId: string,
  answers: Record<string, string>,
): Promise<void> {
  await agentApiClient.post("/api/reply", { body: { sessionId, answers } });
}
